"use client";

import { useEffect, useRef, useState } from "react";
import { Knopf } from "./knopf";

/** Lucide `Copy` als Inline-SVG (das Paket bindet `lucide-react` nicht selbst ein, R-F); Farbe erbt. */
function KopierSymbol() {
  return (
    <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </svg>
  );
}

type Stand = "nein" | "ja" | "fehlt";

/**
 * Kopierknopf einer Steckbrief-Zelle (CMDB Kurzansicht, Betreiber 03.11.2026 „Idee 1“; Muster der Rückmeldung wie `TeilenMenue`: Satz im
 * `role="status"`, „kopiert“ bzw. „Kopieren nicht möglich“, nie Toast). Kopiert wird der fertige Text der Zelle, nichts wird gesendet.
 * Design-Guide `steckbrief.md`, Zeile „Kopierknopf“.
 */
export function SteckbriefKopierknopf({ label, text }: { label: string; text: string }) {
  const [stand, setStand] = useState<Stand>("nein");
  const timer = useRef<number | null>(null);
  useEffect(() => () => {
    if (timer.current !== null) window.clearTimeout(timer.current);
  }, []);

  const kopiere = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setStand("ja");
    } catch {
      setStand("fehlt");
    }
    if (timer.current !== null) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setStand("nein"), 2500);
  };

  return (
    <span className="inline-flex items-center gap-x-1">
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-description-lists/dashed-description-list-with-copy-actions */}
      <Knopf variante="ghost" nurSymbol groesse="xs" label={`${label} kopieren`} titel={`${label} kopieren`} symbol={<KopierSymbol />} onClick={() => void kopiere()} />
      <span role="status" aria-live="polite" className="text-xs font-normal text-muted-foreground-1 empty:hidden">
        {stand === "ja" && "kopiert"}
        {stand === "fehlt" && "Kopieren nicht möglich"}
      </span>
    </span>
  );
}
